<template>
    <div>
        <v-row>
            <v-col>
                <h3 class="text-h4">Users List</h3>
                <p class="text-subtitle-1">list of users</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn 
                    block
                    color="primary"
                    @click="handleNew"
                >
                <v-icon>mdi-plus</v-icon>
                add user
                </v-btn>
            
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field 
                    label="Name"
                    v-model="search.name"
                    outlined
                    dense
                    rounded
                    @input="searchByName"
                ></v-text-field>
            </v-col>
        </v-row>
        
                <v-data-table
                    :items="users"
                    :headers="headers"
                    :loading="loading"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :options.sync="options"
                    dense
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <v-btn icon @click="navgateToDisplay(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                            {{item.name}}
                    </template>
                    <template v-slot:[`item.inactive`]="{ item }">
                        <v-icon :color="item.inactive ? 'error' : 'success'">
                            {{ item.inactive ? 'mdi-account-cancel' : 'mdi-account-check'  }}
                        </v-icon>
                    </template>
                    <template v-slot:[`item.must_change_password`]="{ item }">
                        <v-icon color="warning" v-if="item.must_change_password">
                            mdi-alert-circle-check-outline
                        </v-icon>
                        <span v-else>--</span>
                    </template>
                </v-data-table>
         
    </div>
</template>

<script>
import user from "./../../services/administration/user"
export default {
    data () {
        return {
            users: [],
            loading: false,
            options: {},
            search: {},
            page: 1,
            serverItemsLength: 0,
            headers: [
                { text: "Name", value: "name"},
                { text: "Username", value: "username"},
                { text: "Last Login", value: "last_login"},
                { text: "Active", value: 'inactive' },
                { text: "Change Password", value: "must_change_password" }
            ]
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchUsers();
            }
        }
    },
    methods: {
        fetchUsers() {
            this.loading = true
            user.index({...this.options, ...this.search}).then(response => {
                this.users = response.data.data
                this.serverItemsLength = response.data.total
            }).finally(() => {
                this.loading = false
            })
        },
        searchByName() {
            this.page = 1
            this.fetchUsers();
        },
        navgateToDisplay(item) {
            this.$router.push({ name: "UserDisplay", params: { id: item.id}})
        },
        handleNew() {
            this.$router.push({ name: "User"})
        }
    },
}
</script>

<style>

</style>